import {Directive, ElementRef, Output, EventEmitter, HostListener} from '@angular/core';

/**
 * Created by Rodrigo Quesada on 11/12/16.
 */
@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective {

    // region Output
    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();
    // endregion

    constructor(private _el: ElementRef) {
    }

    @HostListener('document:click', ['$event'])
    public onClick(event: MouseEvent): void {
        let target = event.target;
        if (target && !this._el.nativeElement.contains(target)) {
            this.clickOutside.emit(event);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/events/click-outside/click-outside.directive.ts